import React, { useState, ChangeEvent, FormEvent } from 'react';
import { submitFormViaFetch, FormSubmissionData } from './api';

interface FormData {
    name: string;
    email: string;
    message: string;
}

const ContactForm: React.FC = () => {
    const [formData, setFormData] = useState<FormData>({
        name: '',
        email: '',
        message: ''
    });

    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [submitMessage, setSubmitMessage] = useState<string>('');
    const [submitSuccess, setSubmitSuccess] = useState<boolean | null>(null);

    const handleInputChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        
        setIsSubmitting(true);
        setSubmitMessage('');
        setSubmitSuccess(null);

        try {
            let result = await submitFormViaFetch(formData as FormSubmissionData);
            
            if (result.success) {
                setSubmitSuccess(true);
                setSubmitMessage(result.message);
                
                // Reset form on successful submission
                setFormData({
                    name: '',
                    email: '',
                    message: ''
                });
            } else {
                setSubmitSuccess(false);
                setSubmitMessage(result.message);
            }
        } catch (error) {
            setSubmitSuccess(false);
            setSubmitMessage('Une erreur inattendue s\'est produite. Veuillez réessayer.');
        } finally {
            setIsSubmitting(false);
        }
    };

return (
<div className="bg-[#f5f3ef] min-h-screen">

{/* HEADER */}

<section className="max-w-6xl mx-auto px-10 pt-32 pb-20 text-center">

<p className="text-sm text-neutral-500 mb-4">
Contact
</p>

<h1 className="text-6xl font-light mb-6">
Parlons de ton projet
</h1>

<p className="text-neutral-600 max-w-2xl mx-auto">
Une question ? Un projet photo ?  
Je serai ravie de découvrir ton univers
et d'imaginer les visuels qui le mettront en valeur.
</p>

</section>


<div className="max-w-6xl mx-auto px-10 pb-28 grid md:grid-cols-2 gap-20 items-start">


{/* TEXTE */}

<div>

<h2 className="text-3xl font-light mb-6">
Créons ensemble
</h2>

<p className="text-neutral-600 mb-6">
Chaque projet est unique.  
Raconte-moi ton univers, tes besoins
et les visuels que tu imagines.
</p>

<p className="text-neutral-600">
Je réponds généralement sous 24h.
</p>

</div>



{/* FORM */}

<div className="bg-white rounded-xl p-10 shadow-sm">

<form onSubmit={handleSubmit} className="space-y-6">

<div>

<label className="text-sm text-neutral-600">
Nom complet
</label>

<input
type="text"
name="name"
value={formData.name}
onChange={handleInputChange}
required
className="w-full mt-2 px-4 py-3 border border-neutral-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
/>

</div>


<div>

<label className="text-sm text-neutral-600">
Email
</label>

<input
type="email"
name="email"
value={formData.email}
onChange={handleInputChange}
required
className="w-full mt-2 px-4 py-3 border border-neutral-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
/>

</div>


<div>

<label className="text-sm text-neutral-600">
Message
</label>

<textarea
name="message"
rows={5}
value={formData.message}
onChange={handleInputChange}
required
className="w-full mt-2 px-4 py-3 border border-neutral-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
/>

</div>


<button
type="submit"
disabled={isSubmitting}
className="w-full bg-black text-white py-4 rounded-full"
>
{isSubmitting ? "Envoi..." : "Envoyer mon message"}
</button>

</form>


{/* SUCCESS / ERROR */}

{submitMessage && (

<div className={`mt-6 p-4 rounded-lg text-center ${
submitSuccess
? "bg-green-50 text-green-800"
: "bg-red-50 text-red-800"
}`}>

{submitSuccess
? "✅ Message envoyé ! Je te réponds rapidement."
: submitMessage}

</div>

)}

</div>

</div>

</div>
);
};

export default ContactForm;